const fieldPortfolioData = {
    title: {
        value    : undefined,
        required : true,
    },
    place: {
        value    : undefined,
        location : undefined,
        required : true,
    },
    price: {
        value    : undefined,
        required : true,
    },
    description: {
        value    : undefined,
        required : true,
    },
    images: {
        value    : undefined,
        min      : 1,
        max      : 12,
        required : true,
    },
};

export default fieldPortfolioData;
